import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

const pathBlacklist = ['/auth', '/maintenance', '/onboarding'];
const SAVED_URL = 'savedUrl';

@Injectable({
  providedIn: 'root',
})
export class SavedUrlService {
  constructor(private router: Router) {}

  get url(): string {
    return localStorage.getItem(SAVED_URL) || '/dashboard';
  }

  set url(value: string) {
    localStorage.setItem(SAVED_URL, value);
  }

  public clear(): void {
    localStorage.removeItem(SAVED_URL);
  }

  public setUrlIfNotBlacklisted(url: string): void {
    if (!this.isBlacklisted()) {
      this.url = url;
    }
  }

  private isBlacklisted(): boolean {
    return pathBlacklist.findIndex((path) => this.router.isActive(path, false)) !== -1;
  }
}
